// import { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { getProducts, getOrders } from '../services/api';

// export default function Dashboard() {
//   const [productsCount, setProductsCount] = useState(0);
//   const [ordersCount, setOrdersCount] = useState(0);
//   const [pendingOrders, setPendingOrders] = useState(0);

//   useEffect(() => {
//     getProducts().then((data) => setProductsCount(data.length));
//     getOrders().then((data) => {
//       setOrdersCount(data.length);
//       setPendingOrders(data.filter((o) => o.status === 'pending').length);
//     });
//   }, []);

//   return (
//     <div>
//       <h1 className="text-3xl font-black text-white mb-8">لوحة التحكم</h1>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//         <Link
//           to="/products"
//           className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1"
//         >
//           <div className="text-4xl font-black text-white">{productsCount}</div>
//           <div className="text-neutral-400 mt-2">منتج</div>
//         </Link>

//         <Link
//           to="/orders"
//           className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1"
//         >
//           <div className="text-4xl font-black text-white">{ordersCount}</div>
//           <div className="text-neutral-400 mt-2">طلب</div>
//         </Link>

//         <Link
//           to="/orders"
//           className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1"
//         >
//           <div className="text-4xl font-black text-red-500">{pendingOrders}</div>
//           <div className="text-neutral-400 mt-2">طلب معلق</div>
//         </Link>

//         <Link
//           to="/products/add"
//           className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1"
//         >
//           <div className="text-4xl font-black text-red-500">+</div>
//           <div className="text-neutral-400 mt-2">إضافة منتج</div>
//         </Link>
//       </div>
//     </div>
//   );
// }
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts, getOrders } from '../services/api';

export default function Dashboard() {
  const [productsCount, setProductsCount] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);
  const [pendingOrders, setPendingOrders] = useState(0);
  const [confirmedOrders, setConfirmedOrders] = useState(0);
  const [shippedOrders, setShippedOrders] = useState(0);
  const [deliveredOrders, setDeliveredOrders] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);

  const fetchData = () => {
    getProducts().then((data) => setProductsCount(data.length));
    getOrders().then((data) => {
      setOrdersCount(data.length);
      setPendingOrders(data.filter((o) => o.status === 'pending').length);
      setConfirmedOrders(data.filter((o) => o.status === 'confirmed').length);
      setShippedOrders(data.filter((o) => o.status === 'shipped').length);
      setDeliveredOrders(data.filter((o) => o.status === 'delivered').length);
      const revenue = data
        .filter((o) => o.status === 'delivered')
        .reduce((sum, o) => sum + (Number(o.total) || 0), 0);
      setTotalRevenue(revenue);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <h1 className="text-3xl font-black text-white mb-8">لوحة التحكم</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        <Link to="/products" className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1">
          <div className="text-4xl font-black text-white">{productsCount}</div>
          <div className="text-neutral-400 mt-2">منتج</div>
        </Link>
        <Link to="/orders" className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1">
          <div className="text-4xl font-black text-white">{ordersCount}</div>
          <div className="text-neutral-400 mt-2">إجمالي الطلبات</div>
        </Link>
        <div className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800">
          <div className="text-4xl font-black text-red-500">{pendingOrders}</div>
          <div className="text-neutral-400 mt-2">طلبات معلقة</div>
        </div>
        <Link to="/products/add" className="bg-neutral-900 p-8 rounded-xl text-center border border-neutral-800 hover:border-red-600/50 transition transform hover:-translate-y-1">
          <div className="text-4xl font-black text-red-500">+</div>
          <div className="text-neutral-400 mt-2">إضافة منتج</div>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {[
          { label: 'مؤكد', count: confirmedOrders, color: 'text-blue-400', bg: 'bg-blue-400/10', border: 'border-blue-400/30' },
          { label: 'تم الشحن', count: shippedOrders, color: 'text-yellow-400', bg: 'bg-yellow-400/10', border: 'border-yellow-400/30' },
          { label: 'تم التوصيل', count: deliveredOrders, color: 'text-green-400', bg: 'bg-green-400/10', border: 'border-green-400/30' },
          { label: 'الإيرادات', count: `${totalRevenue} ₪`, color: 'text-red-400', bg: 'bg-red-400/10', border: 'border-red-400/30' },
        ].map((item, i) => (
          <div key={i} className={`${item.bg} ${item.border} border rounded-xl p-5 text-center`}>
            <div className={`text-2xl font-black ${item.color}`}>{item.count}</div>
            <div className="text-neutral-400 text-sm mt-1">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}